import React from "react";
import { Header } from "@/components/header";
import { ChartCard } from "@/components/chart-card";
import { ApiPath } from "@/api/path";
import { Dropdown } from "@/components/location-switcher";
import { DatumCardQuery } from "@/components/datum-card-query";
import { useDateRange } from "@/dateRanges/DateRangeContext";
import { DEFAULT_OVERVIEW_RANGE } from "@/dateRanges/dateRanges";
import { OFF } from "@/dateRanges/refreshIntervals";
import { ONE_HOUR } from "@/dateRanges/windowSizes";
import { QueryProps } from "@/api/api";
import { formatUnit } from "@/metrics/formatValueAndUnit";
import { useSelectedAssets } from "@/contexts/SelectedAssetsContext";
import { getDatum, SeriesDatumName } from "@/components/charts/lineChartResponse";
import { useMetricNames } from "@/metrics/api";

const InstallationMetrics = () => {
  const { selectedAssets } = useSelectedAssets();
  const { dateRange, windowSize } = useDateRange({
    overrideDefaultDateRange: DEFAULT_OVERVIEW_RANGE,
    overrideDefaultWindowSize: ONE_HOUR,
    overrideDefaultRefreshInterval: OFF
  });

  const { data: metricNames } = useMetricNames();

  const metricOptions = metricNames.map((name) => ({ id: name, name }))
  const [selectedMetric, setSelectedMetric] = React.useState(metricOptions[0])

  if (!selectedAssets || selectedAssets.length === 0) {
    return (
      <p>Loading</p>
    )
  }

  const query: QueryProps = {
    windowSize,
    dateRange,
    metric: selectedMetric.id,
    installation_id: selectedAssets.map((installation) => installation.id),
  }

  return (
    <>
      <Header
        name="Installation metrics"
        className="font-normal text-4xl"
        showDatePicker
      />
      <Dropdown
        className="w-fit"
        options={metricOptions}
        placeholder="Select a metric"
        selectedItem={selectedMetric}
        onSelect={(option: any) => setSelectedMetric(option)}
      />
      <ChartCard
        className="col-span-12 flex-1 lg:col-span-6"
        title={selectedMetric.name}
        height={450}
        yAxisName={selectedMetric.name}
        apiPath={ApiPath.INSTALLATION_GENERIC_LINE_CHART_QUERY}
        query={[query]}
      />
      <div className="grid grid-cols-10 gap-2">
        {
          [
            { id: SeriesDatumName.LATEST, title: "Latest" },
            { id: SeriesDatumName.MAXIMUM, title: "Maximum" },
            { id: SeriesDatumName.MINIMUM, title: "Minimum" },
            { id: SeriesDatumName.AVERAGE, title: "Average" },
            { id: SeriesDatumName.SUM, title: "Sum" },
          ].map(({ id, title }) => (
            <DatumCardQuery
              key={id}
              className="col-span-2 lg:col-span-2"
              title={title}
              apiPath={ApiPath.INSTALLATION_GENERIC_LINE_CHART_QUERY}
              suffixFn={(res: any) => formatUnit(res?.legend.unit) || ""}
              accessorFn={getDatum("overall", id)}
              decimalPoints={3}
              query={query}
            />
          ))
        }
      </div>
    </>
  )
}

export default InstallationMetrics;
